import React, { useEffect, useState } from 'react';

// Placeholder image
const whyChooseUsImage =
  "https://i.pinimg.com/1200x/42/01/1a/42011a09fbdbb39820575fa555e579f2.jpg";

const benefits = [
  {
    icon: "🚀",
    title: "Strategic Digital Growth",
    text: "We design and execute digital strategies that align with your business goals so every campaign moves the needle, not just the numbers.",
  },
  {
    icon: "📈",
    title: "Performance-Driven Marketing",
    text: "Data, testing and optimization power our decisions, helping you get more qualified leads, sales and long-term ROI from your budget.",
  },
  {
    icon: "🌐",
    title: "Stronger Online Presence",
    text: "From website to social media and ads, we create a consistent, professional brand experience that builds trust with your audience.",
  },
  {
    icon: "🤝",
    title: "Dedicated Partnership",
    text: "Clear communication, transparent reporting and ongoing support so you always know what’s happening and why it matters.",
  },
];

const WhyChooseUsSection = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [isTablet, setIsTablet] = useState(
    window.innerWidth > 768 && window.innerWidth <= 1024
  );

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
      setIsTablet(window.innerWidth > 768 && window.innerWidth <= 1024);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const styles = {
    container: {
      fontFamily: "Arial, sans-serif",
      width: "100%",
      backgroundColor: "#fff",
    },

    contentSection: {

      maxWidth: "1440px",
      margin: "0 auto",
      // paddingTop: isMobile ? "0px" : "0px",
      paddingBottom: isMobile ? "40px" : "64px",
      paddingLeft: isMobile ? "16px" : "24px",
      paddingRight: isMobile ? "16px" : "24px",
    },

    headerSection: {
      textAlign: "center",
      maxWidth: "700px",
      margin: "0 auto 40px auto",
      padding: isMobile ? "0 10px" : "0",
    },

    mainTitle: {
      fontSize: isMobile ? "1.75rem" : "2.5rem",
      fontWeight: 700,
      color: "#111827",
      margin: "0 0 12px 0",
      letterSpacing: "-0.02em",
    },

    shortDescription: {
      fontSize: isMobile ? "0.95rem" : "1.1rem",
      color: "#4b5563",
      lineHeight: "1.6",
      margin: 0,
    },

    gridContainer: {
      display: "grid",
      gridTemplateColumns: isMobile ? "1fr" : "1.15fr 0.85fr",
      gap: isMobile ? "24px" : isTablet ? "28px" : "36px",
      alignItems: "center",
    },

    leftSide: {
      display: "flex",
      flexDirection: "column",
      gap: isMobile ? "16px" : "24px",
      width: "100%",
    },

    card: {
      display: "flex",
      alignItems: isMobile ? "flex-start" : "center",
      gap: isMobile ? "16px" : "24px",
      backgroundColor: "#ffffff",
      padding: isMobile ? "18px" : "24px",
      borderRadius: "10px",
      boxShadow: "0 1px 8px rgba(0, 0, 0, 0.08)",
      border: "1px solid #f1f5f9",
      width: "100%",
    },

    iconWrapper: {
      width: isMobile ? "52px" : "64px",
      height: isMobile ? "52px" : "64px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontSize: isMobile ? "1.8rem" : "2.25rem",
      backgroundColor: "#e0f2fe",
      borderRadius: "10px",
      flexShrink: 0,
    },

    cardContent: {
      flex: 1,
    },

    cardTitle: {
      fontSize: isMobile ? "1rem" : "2rem",
      fontWeight: 700,
      color: "#111827",
      margin: 0,
      lineHeight: 1.4,
    },

    cardText: {
      marginTop: "6px",
      fontSize: isMobile ? "0.9rem" : "0.95rem",
      color: "#4b5563",
      lineHeight: "1.7",
      marginBottom: 0,
    },

    rightSide: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      width: "100%",
      order: isMobile ? -1 : 0,
    },

    imageFrame: {
      position: "relative",
      border: isMobile ? "10px solid #ffffff" : "16px solid #ffffff",
      boxShadow: "0 10px 20px rgba(0, 0, 0, 0.12)",
      borderRadius: "12px",
      overflow: "hidden",
      aspectRatio: "4 / 5",
      width: "100%",
      maxWidth: isMobile ? "100%" : isTablet ? "400px" : "484px",
    },

    image: {
      width: "100%",
      height: "100%",
      objectFit: "cover",
      display: "block",
    },
  };

  return (
    <div style={styles.container}>
      <section style={styles.contentSection}>

        {/* --- Added Title & Description Section --- */}
        {/* <div style={styles.headerSection}>
          <h2 style={styles.mainTitle}>Why Choose Us</h2>
          <p style={styles.shortDescription}>
            We combine strategic thinking, technical innovation, and dedicated support 
            to help your business thrive and achieve sustainable long-term success.
          </p>
        </div> */}

        <div style={styles.gridContainer}>
          {/* Left Side: Benefit Cards */}
          <div style={styles.leftSide}>
            {benefits.map((benefit, index) => (
              <div key={index} style={styles.card}>
                <div style={styles.iconWrapper}>{benefit.icon}</div>

                <div style={styles.cardContent}>
                  <h3 style={styles.cardTitle}>{benefit.title}</h3>
                  <p style={styles.cardText}>{benefit.text}</p>
                </div>
              </div>
            ))}
          </div>

          {/* Right Side Image */}
          <div style={styles.rightSide}>
            <div style={styles.imageFrame}>
              <img
                src={whyChooseUsImage}
                alt="Why Choose Us"
                style={styles.image}
              />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default WhyChooseUsSection;